module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/209.6aaa09da.png";